import React from "react";
import useCustomerContext from "modules/customers/hooks/useCustomerContext";
import EventCity from "../../modules/eventCities/types/EventCity";

interface CustomerDescriptionProps {
    eventCity?: EventCity;
}

const CityEventDescription = ({
    eventCity,
}: CustomerDescriptionProps) => {
    const { languageCode } = useCustomerContext();

    if (!eventCity) {
        return null;
    }

    return (<span dangerouslySetInnerHTML={{__html: eventCity.information[languageCode]}}/>);
}

export default CityEventDescription;
